import { render, staticRenderFns } from "./colorThemeSelector.vue?vue&type=template&id=14513b14"
import script from "./colorThemeSelector.vue?vue&type=script&lang=js"
export * from "./colorThemeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports